import type { ComputedRef, InjectionKey } from "vue";
import type { ConditionalRuleEvaluation } from "./conditionalRules";

export const ConditionalRuleEvaluationKey: InjectionKey<
  ComputedRef<ConditionalRuleEvaluation>
> = Symbol("conditional-rule-evaluation");
